<!--官方号详情-->
<template>
  <div class="official-number-details-container">
    <header-index/>
    <div class="official-number-details-content">
      <div class="official-number-details-top" :style="'background: url('+officialNumberDetails.bgImg+')'">
        <div class="bigger-li">{{ officialNumberDetails.position }}</div>
      </div>
      <div class="official-number-details-content-list">
        <el-row :gutter="24">
          <el-col :span="17">
            <div class="personal-header">
              <el-tabs v-model="activeIndex" @tab-click="handleSelect">
                <el-tab-pane v-for="rest of componentRest" :label="rest.name" :name="rest.fid.toString()"
                             v-show="rest.isSee==1"/>
              </el-tabs>
            </div>
            <template v-if="dynamicList.length>0 && activeIndex!= '6' && activeIndex!= '7'">
              <div v-for="dynamic of dynamicList"  class="dynamic-list"  @click="dynamicDetails(dynamic)">
                <div v-if="dynamic.photo.length<1">
                  <p class="span-bold" v-if="dynamic.title!=''">{{ dynamic.title }}</p>
                  <p class="span-bold" v-else>{{ dynamic.keyword }}</p>
                  <p>
                    <span v-if="dynamic.is_top==1" class="span-red">置顶</span>
                    <span class="span-default">{{ dynamic.user_name }}</span>
                    <span class="span-default">{{ dynamic.time }}</span>
                  </p>
                </div>
                <div v-else-if="dynamic.photo.length<3">
                  <el-row>
                    <el-col :span="5">
                      <el-image :src="dynamic.photo[0]" style="height: 110px;width: 100%" fit="cover"/>
                      <i class="iconfont icon-bofang" v-if="dynamic.type==2"/>
                    </el-col>
                    <el-col :span="19" style="padding-left: 10px;">
                      <p class="span-bold" v-if="dynamic.title!=''">{{ dynamic.title }}</p>
                      <p class="span-bold" v-else>{{ dynamic.keyword }}</p>
                      <p>
                        <span v-if="dynamic.is_top==1" class="span-red">置顶</span>
                        <span class="span-default">{{ dynamic.user_name }}</span>
                        <span class="span-default">{{ dynamic.time }}</span>
                      </p>
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <p class="span-bold" v-if="dynamic.title!=''">{{ dynamic.title }}</p>
                  <p class="span-bold" v-else>{{ dynamic.keyword }}</p>
                  <el-row>
                    <el-col :span="5" v-for="(photo,index) of dynamic.photo" v-if="index<3" class="imgs">
                      <el-image :src="photo" style="height: 110px;width: 100%" fit="cover"/>
                    </el-col>
                  </el-row>
                  <p>
                    <span v-if="dynamic.is_top==1" class="span-red">置顶</span>
                    <span class="span-default">{{ dynamic.user_name }}</span>
                    <span class="span-default">{{ dynamic.time }}</span>
                  </p>
                </div>
              </div>
            </template>
            <template v-else-if="dynamicList.length>0 && activeIndex== '6'">
              <div v-for="dynamic of dynamicList" class="jobListings-list">
                <div class="table-group" @click="positionDetails(dynamic)">
                  <div class="table-header">
                    <div class="table-group-th">
                      <span class="bold-span">{{ dynamic.name }}</span>
                      <span class="red-span">{{ dynamic.salary }}</span>
                    </div>
                    <div class="table-group-td">
                      <span class="normal-span">{{ dynamic.workArea }}</span>
                      <el-divider direction="vertical"/>
                      <span class="normal-span">{{ dynamic.workingYears }}</span>
                      <el-divider direction="vertical"/>
                      <span class="normal-span">{{ dynamic.education }}</span>
                    </div>
                  </div>
                  <div class="table-bottom">
                    <el-avatar fit="cover" :src="dynamic.logo" :size="48"/>
                    <div style="padding-left: 10px;">
                      <p>{{ dynamic.companyName }}</p>
                      <span class="normal-span">{{ dynamic.businessNature }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="dynamicList.length>0 && activeIndex== '7'">
              <div v-for="dynamic of dynamicList" class="bidding-list">
                <div class="grid-content bg-purple" @click="biddingDetails(dynamic)">
                  <i class="tag-1">
                    <span class="tag-red">招投标</span>
                    <span class="tag-white">{{ dynamic.money }}{{ dynamic.moneyUnit }}</span>
                  </i>
                  <i class="tag-2" v-if="dynamic.urgent==1">急</i>
                  <i class="tag-2" v-if="dynamic.top==1">置顶</i>
                  <p class="small-title SourceHanSansCN">{{ dynamic.title }}</p>
                  <p class="bottom-p">
                    <span class="left-span">
                      <i class="iconfont icon-clock"/>
                      {{ dynamic.statusFormat }}
                    </span>
                    <span class="right-span">
                      <i class="iconfont icon-user"/>
                      {{ dynamic.nums }}人报名
                    </span>
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <el-empty description="暂无内容"/>
            </template>
            <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
                  :limit="tablePage.pageSize" style="padding: 20px 25px 15px 0px;"/>
          </el-col>
          <el-col :span="7">
            <el-card class="box-card" style="margin: 30px 0px;" shadow="hover">
              <div class="official-avatar-top">
                <div class="official-avatar">
                  <el-image class="official-img" :src="officialNumberDetails.useravatar" fit="contain"/>
                  <i class="official-icon">官</i>
                </div>
                <div class="official-follow">
                  <span class="red_plain_button" v-if="personalInfo.is_follow==0" @click="editFollowMethod">关注</span>
                  <span class="red_plain_button" v-else @click="editFollowMethod">已关注</span>
                </div>
              </div>
              <div class="official-avatar-bottom">
                <p class="official-position">{{ officialNumberDetails.position }}</p>
                <p class="official-grey">{{ officialNumberDetails.authenticationInfo }}</p>
                <div style="display: flex;">
                  <el-tooltip :content="officialNumberDetails.currentCity" placement="bottom"
                              v-if="officialNumberDetails.currentCity">
                    <el-button type="danger" class="el-danger" plain>
                      <i class="el-icon-location" style="padding-right: 10px;"/>{{ officialNumberDetails.currentCity }}
                    </el-button>
                  </el-tooltip>
                  <el-tooltip :content="officialNumberDetails.industry" placement="top"
                              v-if="officialNumberDetails.industry">
                    <el-button type="primary" plain class="el-normal">{{ officialNumberDetails.industry }}</el-button>
                  </el-tooltip>
                </div>
              </div>
            </el-card>
            <open-cloud/>
          </el-col>
        </el-row>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import {editFollow, homepageComponentRest, microArticleLists, personal, homepageJobListings} from '@/api/interfaceApi'
import {getCustomInfo} from '@/api/systemSetting'
import {myTenderList} from '@/api/cloudServiceApi'
import page from "@/components/page/pages";
import OpenCloud from "@/components/children/openCloud";
import cityJson from "@/static/cityJson.json";

export default {
  name: "officialNumberDetails",
  components: {OpenCloud, Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      id: 0,
      cid: 0,
      officialNumberDetails: [],
      componentRest: [],
      activeIndex: '',
      dynamicList: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      personalInfo: {},
      cityList: {},
    }
  },
  methods: {
    /*获取官方号标签以用于数据分类读取*/
    getComponentRest() {
      homepageComponentRest({
        bid: this.id, cid: this.cid
      }).then(res => {
        if (res.code == 200) {
          this.componentRest = res.content;
          if (this.activeIndex == '') {
            this.activeIndex = this.componentRest[0].fid.toString();
            sessionStorage.setItem('officialIndex', this.activeIndex);
            this.getDynamicListInfo();
          } else {
            this.getDynamicListInfo();
          }
        }
      })
    },
    /*获取官方号详情数据*/
    getOfficialNumberDetails() {
      getCustomInfo({cid: this.id, uid: this.cid}).then(res => {
        if (res.code == 200) {
          this.officialNumberDetails = res.data;
        }
      })
    },
    /*监听导航栏切换*/
    handleSelect(tab, event) {
      this.activeIndex = tab.name;
      this.tablePage.currentPage = 1;
      this.getDynamicListInfo();
    },
    /**
     * @event 获取动态文章等列表数据
     * @param type  查询类型（1:动态， 2：文章， 3：视频）
     * */
    getDynamicListInfo() {
      let that = this;
      if (that.activeIndex == 1 || that.activeIndex * 1 == 2 || that.activeIndex * 1 == 3) {
        microArticleLists({
          bid: that.id,
          page: that.tablePage.currentPage,
          type: that.activeIndex * 1,
          uid: that.cid
        }).then(res => {
          if (res.code == 200) {
            sessionStorage.setItem('officialIndex', that.activeIndex);
            that.dynamicList = res.content;
            that.tablePage.total = res.total;
          }
        })
      } else if (that.activeIndex * 1 == 4) {/*店铺*/
        /*跳转店铺详情*/
        let routeData = that.$router.resolve({
          name: "shop",
          path: '/storeManagement/shop',
          query: {
            id: that.personalInfo.shopId,
            pName: that.cityList.abridge + '企服务云'
          }
        });
        window.open(routeData.href, '_blank')
      } else if (that.activeIndex * 1 == 5) {/*关于我们*/
        /*跳转企业详情*/
        let routeData = that.$router.resolve({
          name: "enterpriseDetails",
          path: '/enterpriseDetails/index',
          query: {
            id: that.officialNumberDetails.bccCid
          }
        });
        window.open(routeData.href, '_blank')
      } else if (that.activeIndex * 1 == 6) {/*招聘*/
        homepageJobListings({
          bid: that.id,
          page: that.tablePage.currentPage,
          pageLimit: that.tablePage.pageSize,
          type: 1,
          uid: that.cid
        }).then(res => {
          if (res.code == 200) {
            sessionStorage.setItem('officialIndex', that.activeIndex);
            that.dynamicList = res.content.rows;
            that.tablePage.total = res.content.total;
          }
        })
      } else if (that.activeIndex * 1 == 7) {/*外包需求*/
        myTenderList({
          bid: that.id,
          page: that.tablePage.currentPage,
          pageLimit: that.tablePage.pageSize,
          status: null,
          uid: that.cid
        }).then(res => {
          if (res.code == 200) {
            sessionStorage.setItem('officialIndex', that.activeIndex);
            that.dynamicList = res.content.rows;
            that.tablePage.total = res.content.total;
          }
        })
      }
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getDynamicListInfo();
    },
    /*获取当前登录用户是否关注*/
    getPersonal() {
      personal({bid: this.id, uid: this.cid}).then(res => {
        if (res.code == 200) {
          this.personalInfo = res.content;
        }
      })
    },
    // 关注
    editFollowMethod() {
      if (this.cid != 0) {
        editFollow({bid: this.id, uid: this.cid}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.getPersonal();
          }
        });
      } else {
        this.$message.error("请登录后操作");
      }
    },
    /*招聘详情*/
    positionDetails(row) {
      let routeData = this.$router.resolve({
        name: "positionDetail",
        query: {id: row.id},
        path: '/serviceNet/positionDetails'
      });
      window.open(routeData.href, '_blank')
    },
    /*招标详情*/
    biddingDetails(demand) {
      let routeData = this.$router.resolve({
        query: {id:demand.zid},
        path: '/outsourceDemand/biddingDetails'
      });
      window.open(routeData.href, '_blank')
    },
    /*文章动态详情*/
    dynamicDetails(row){
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (row.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query:{
            id:row.id,
            type:row.type,
          },
          params:{cid:this.cid},
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      }else if(row.type == 1 && row.method_type=='policy') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query:{
            id:row.id,
            type:3,
          },
          params:{cid:this.cid},
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      }else {
        if (row.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.method_type == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (row.category_method == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        }else if(row.method_type == "article"){
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query:{
              id:row.id,
              type:1,
            },
            params:{cid:this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query:{
              id:row.id,
              type:row.type,
            },
            params:{cid:this.cid},
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    }
  },
  mounted() {
    this.getComponentRest();
    this.getOfficialNumberDetails();
    this.getPersonal();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.cid = sessionStorage.getItem('loginData') ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.activeIndex = sessionStorage.getItem('officialIndex') ? sessionStorage.getItem('officialIndex') : '1';
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  },
  beforeDestroy() {
    /*关闭窗口前移除历史定位值*/
    sessionStorage.removeItem('officialIndex');
  },
}
</script>
<style scoped>
.official-number-details-container >>> .official-number-details-content .el-tabs__item {
  margin: 0 60px 0px 0px;
  padding: 0px;
  line-height: 60px;
  font-size: 18px;
  font-weight: 100;
  height: 60px;
  color: #333333;
  font-family: 'SourceHanSansCN';
}

.official-number-details-container >>> .official-number-details-content .el-tabs__item.is-active {
  color: #FE273B;
}

.official-number-details-container >>> .official-number-details-content .el-tabs__active-bar {
  background-color: #ffffff;
}

.official-number-details-container >>> .official-number-details-content .el-tabs__nav-wrap::after {
  background-color: #ffffff;
  height: 0px;
}

.official-number-details-container >>> .official-number-details-content .el-tabs__nav {
  width: -webkit-fill-available;
}
</style>
<style scoped lang="scss">
.official-number-details-container {
  background: #ffffff;

  .official-number-details-content {
    padding: 0px 18% 30px;
    min-width: 76rem;
    background: #ffffff;
    .official-number-details-top {
      height: 340px;
      width: 100vw;
      background-size: 100% 100%;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      align-items: center;
      cursor: pointer;

      .bigger-li {
        font-size: 48px;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        letter-spacing: 10px;
        color: #FFFFFF;
      }
    }

    .official-number-details-content-list {
      .dynamic-list {
        padding: 15px 0px;

        .span-bold {
          font-size: 20px;
          font-family: 'SourceHanSansCN';
          color: #333;
          margin-block-start: 0em;
          margin-block-end: 0em;
        }

        .p-bold {
          font-size: 18px;
          font-weight: 100;
          font-family: 'SourceHanSansCN';
          color: #333;
          margin-block-start: 0em;
          margin-block-end: 0em;
          min-height: 80px;
        }

        .imgs {
          margin-right: 10px;
          margin-top: 10px;
        }

        p {
          font-size: 16px;
          margin-block-start: 10px;
          margin-block-end: 10px;

          .span-red {
            color: #FE273B;
            font-size: 14px;
            padding-right: 20px;
            font-weight: 100;
            font-family: 'SourceHanSansCN';
          }

          .span-default {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
            font-weight: 100;
            padding-right: 20px;
          }
        }

        .icon-bofang {
          font-size: 30px;
          color: white;
          margin-top: 4.5%;
          position: absolute;
          margin-left: -12.2%;
        }

      }

      .jobListings-list {
        padding-top: 20px;

        .table-group {
          background: #ffffff;
          padding-bottom: 20px;
          border-bottom: 1px solid #E7E9F5;

          .table-header {
            border-bottom: 1px solid #f5f5f5;

            .table-group-th {
              display: flex;
              justify-content: space-between;

              .bold-span {
                color: #333333;
                font-size: 18px;
                font-weight: bold;
                font-family: 'SourceHanSansCN';
              }

              .red-span {
                color: #FE273B;
                font-size: 18px;
                font-family: 'SourceHanSansCN';
              }
            }

            .table-group-td {
              line-height: 45px;

              .el-divider {
                background-color: #999999;
              }

              .normal-span {
                color: #333333;
                font-family: 'SourceHanSansCN';
                font-size: 14px;
              }
            }
          }

          .table-bottom {
            display: flex;
            align-items: center;

            p {
              margin-block-start: 10px;
              margin-block-end: 5px;
            }

            .el-divider {
              background-color: #999999;
            }

            .normal-span {
              color: #666666;
              font-family: 'SourceHanSansCN';
              font-size: 14px;
            }
          }
        }
      }
      .bidding-list{
        padding: 15px 0px 15px 0px;
        border-bottom: 1px solid #E7E9F5;
        .bg-purple {
          padding:0px 20px 0px 0px;
          .small-title {
            color: #333333;
            font-size: 18px;
            text-align: left;
            cursor: context-menu;
            margin-block-end: 0em;
            padding-top: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;
            margin-block-start: 5px;

            .user-name {
              font-size: 16px;
              color: #333333;
            }

            .el-position {
              font-style: normal;
              font-size: 12px;
              color: #ffffff;
              background: #FF9600;
              padding: 3px 5px;
              border-radius: 4px;
              margin-left: 10px;
            }

            .right-icon {
              float: right;
              width: 30px;
              height: 30px;

              .icon-phone {
                background: url("~@/assets/img/cloud/dianhua.png");
                width: 30px;
                height: 30px;
                background-size: 100% 100%;
                position: absolute;
                cursor: pointer;
              }
            }
          }

          .gray-p {
            color: #999999;
            font-size: 14px;
          }

          .tag-1 {
            font-style: normal;
            cursor: pointer;
            height: min-content;
            display: inline-flex;

            .tag-red {
              padding: 10px;
              color: #ffffff;
              background: #FE273B;
              font-size: 14px;
              border-radius: 6px 0px 0px 6px;
              border: 1px solid #FE273B;
            }

            .tag-white {
              padding: 10px;
              color: #FE273B;
              background: white;
              font-size: 14px;
              border: 1px solid #FE273B;
              border-radius: 0px 6px 6px 0px;
            }
          }

          .tag-2 {
            font-style: normal;
            color: #FE273B;
            border-radius: 6px;
            border: 1px solid #FE273B;
            padding: 10px;
            margin-left: 20px;
            font-size: 14px;
            cursor: pointer;
          }

          .bottom-p {
            margin-block-start: 0em;
            margin-block-end: 0em;
            padding-top: 5px;

            .left-span {
              color: #666666;
              font-size: 14px;
            }

            .right-span {
              color: #666666;
              font-size: 14px;
              float: right;
            }

            .iconfont {
              color: #333333;
            }
          }
        }
      }
    }
  }

  .official-avatar-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .official-avatar {
      .official-icon {
        position: absolute;
        font-size: 12px;
        background: #1637FF;
        color: #ffffff;
        font-style: normal;
        padding: 2px 5px;
        border-radius: 50%;
        margin-top: 40px;
        margin-left: -15px;
      }

      .official-img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #d1d1d1;
      }
    }

    .official-follow {
      .red_plain_button {
        border-radius: 6px;
        text-align: center;
        border: 1px solid #fe273b;
        color: #fe273b;
        cursor: pointer;
        font-size: 14px;
        padding: 5px 10px;
      }
    }
  }

  .official-avatar-bottom {
    .official-position {
      font-size: 18px;
      font-family: 'SourceHanSansCN';
      font-weight: bold;
      color: #333333;
      margin-block-start: 20px;
      margin-block-end: 10px;
    }

    .official-grey {
      margin-block-start: 0px;
      margin-block-end: 20px;
      color: #999999;
      font-size: 14px;
      font-family: 'SourceHanSansCN';
    }

    .el-danger {
      background: #FFE7E9;
      padding: 10px;
      color: #FE273B;
      border-radius: 6px;
      font-size: 14px;
      font-family: "SourceHanSansCN";
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-all;
      width: 40%;
      white-space: nowrap;
    }

    .el-normal {
      background: #EBEEFF;
      padding: 10px;
      border-radius: 6px;
      color: #1637FF;
      margin-left: 10px;
      font-size: 14px;
      font-family: 'SourceHanSansCN';
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-all;
      width: 60%;
      white-space: nowrap;
    }
  }
}
</style>